import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyNames } from '@webapp/core/entities/external/Currency'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { DetailedCard, type DetailedCardConstructor } from './DetailedCard'
import { CardholderAccountStatuses } from '../enums/CardholderAccountStatusEnum'
import { CardStatuses } from '../enums/CardStatusEnum'
import { CardTypes } from '../enums/CardTypeEnum'
import { IssuingProviders } from '../enums/IssuingProvider'

export const DetailedCardConstructorFactory =
  Factory.Sync.makeFactory<DetailedCardConstructor>({
    id: Factory.each(() => faker.random.number()),
    externalId: Factory.each(() => faker.random.uuid()),
    last4Digits: Factory.each(() => faker.random.number().toString()),
    type: Factory.each(() =>
      faker.random.arrayElement(Object.values(CardTypes))
    ),
    status: Factory.each(() =>
      faker.random.arrayElement(Object.values(CardStatuses))
    ),
    createdAt: Factory.each(() => faker.date.past().toISOString()),
    updatedAt: Factory.each(() => faker.date.past().toISOString()),
    requireActivation: false,
    balance: Factory.each(() => faker.finance.amount()),
    currencyName: CurrencyNames.USD,
    shippingAddress: Factory.each(() => ({
      name: faker.name.firstName(),
      addressLine1: faker.address.streetAddress(),
      addressLine2: null,
      postalCode: faker.address.zipCode(),
      city: faker.address.city(),
      stateProvince: faker.address.state(),
      country: faker.address.country(),
    })),
    cardholder: {
      id: faker.random.number(),
      externalId: faker.random.uuid(),
      userId: faker.random.number(),
      firstName: faker.name.firstName(),
      lastName: faker.name.lastName(),
      email: faker.internet.email(),
      secondaryCategoryId: faker.random.number(),
      profileImage: faker.image.imageUrl(),
      tosAccepted: faker.random.boolean(),
      status: CardholderAccountStatuses.ACTIVE,
      provider: IssuingProviders.AIRWALLEX,
      billingAddress: {
        name: `${faker.name.firstName()} ${faker.name.lastName()}`,
        addressLine1: faker.address.streetAddress(),
        addressLine2: null,
        postalCode: faker.address.zipCode(),
        city: faker.address.city(),
        stateProvince: faker.address.state(),
        country: faker.address.country(),
      },
    },
  })

export const CardDetailsFactory = EntityFactory(
  DetailedCard,
  DetailedCardConstructorFactory
)
